<template>
    <div class="style">
        <!--弹出框-->
        <el-dialog :title="dialogTitle" :close-on-click-modal=false :visible.sync="dialogVisible" width="400px" :close="handleClose">
            <div class="title">
                <span class="checktip">* </span>系列分组：
                <el-input v-model="dialogData.name" style="width: 230px;" placeholder="系列分组"></el-input>
            </div>
            <span slot="footer" class="dialog-footer">
		    <el-button @click="dialogVisible = false">取 消</el-button>
		    <el-button type="primary" @click="handleConfirm()">确 定</el-button>
		  </span>
        </el-dialog>
        <div>
            <!--<navZcy v-bind:num="9"></navZcy>
            <management></management>-->
        </div>
        <div class="dataTag">
            <div class="handle">
                <div class="fl">
                    <img src="../assets/img/dataIcon.png" style="vertical-align: middle;" />
                    <span class="" style="display: inline-block; vertical-align: middle;">数据列表</span>
                </div>
                <div class="handleBtn fr">
                    <el-button type="primary" size="small" @click="handleAdd">添加</el-button>
                    <el-button type="danger" size="small" @click="handleDelete(0,0)">批量删除</el-button>
                </div>
            </div>
            <!--列表内容-->
            <div class="tableData" style="text-align: center;">
                <el-table
                        ref="multipleTable"
                        :data="tableData"
                        border
                        @selection-change="handleSelectionChange"
                        style="width: 100%;border-bottom: 1px solid #ddd;">
                    <el-table-column type="selection" width="150px">
                    </el-table-column>
                    <el-table-column type="index" label="序号" width="200px">
                    </el-table-column>
                    <el-table-column prop="name" label="空间类型" width="250px">
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <a href="javascript:void(0)" @click="handleEdit(scope.$index, scope.row)" style="color: #1ABC9C;">编辑</a>
                            <a href="javascript:void(0)" @click="handleDelete(scope.$index, scope.row)" style="color: #1ABC9C;">删除</a>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>

<script>
    import management from './management.vue'
    import navZcy from './nav.vue'
    export default {
        name: "seriesGroup",
        components:{
            management,navZcy
        },
        data() {
            return {
                dialogTitle: '',
                dialogVisible: false,
                tableData: [],
                dialogData: {},
                multipleSelection: []
            }
        },methods: {
            //弹出框关闭
            handleClose: function(done) {
                done();
            },
            getSeriesGroup() {
                this.$http.post("zcvrVideoApi/imgList/getSeriesGroup/"+sessionStorage.getItem('sessionId'),{emulateJson:true}).then(
                    (success)=>{
//		  				console.log(success)
                        if(success.body.msg!="ok"){
                            this.tableData = []
                            this.$message({
                                type: 'error',
                                message: success.data.msg
                            });
                            if(success.data.msg=="该SessionId已经超时"){
                                this.$message.error("登录超时！请重新登录");
                                this.$router.push({path: '/',query: ''})
                            }
                        }else {
                            this.tableData = success.body.data
                        }

                    },
                    (error)=>{
                        console.log("数据连接失败")
                    })
            },
            //添加图片风格
            handleAdd: function() {
                this.dialogTitle = "添加系列分组类型";
                this.dialogData={
                    name: ""
                };
                this.dialogVisible = true;
                setTimeout(function(){
                    $('.input').focus()
                },100)
            },
            //编辑图片风格
            handleEdit: function(index, row) {
                this.dialogTitle = "编辑系列分组类型";
                this.dialogData = {
                    id: row.id,
                    name: row.name
                };
                this.dialogVisible = true;
                setTimeout(function(){
                    $('.input').focus()
                },100)
            },
            //确定添加/编辑
            handleConfirm: function() {
                if(this.dialogData.name){
                    let url = ""
                    const formData = new FormData();
                    formData.append("name",this.dialogData.name)
                    if(this.dialogTitle == "添加系列分组类型"){
                        url = "zcvrVideoApi/imgList/createSeriesGroup/"+sessionStorage.getItem('sessionId')
                    }else{
                        url = "zcvrVideoApi/imgList/updateSeriesGroup/"+sessionStorage.getItem('sessionId')
                        formData.append("id",this.dialogData.id)
                    }
                    this.$fly.post(url,formData).then(
                        (success)=>{
                            console.log(success)
                            if(success.data.msg!="ok"){
                                this.$message({
                                    type: 'error',
                                    message: success.data.msg
                                });
                                if(success.data.msg=="该SessionId已经超时"){
                                    this.$message.error("登录超时！请重新登录");
                                    this.$router.push({path: '/',query: ''})
                                }
                            }else {
                                this.dialogVisible = false
                                this.getSeriesGroup()
                            }
                        },
                        (error)=>{
                            console.log("数据连接失败")
                        })
                }else{
                    this.$message({
                        type: 'error',
                        message: '请输入系列分组名称'
                    });
                }
            },
            //复选框选中
            handleSelectionChange: function(val){
                this.multipleSelection=[]
                for (let i=0; i<val.length; i++) {
                    this.multipleSelection.push(val[i].id)
                }
            },
            //删除图片风格
            handleDelete: function(index, row) {
                let id = []
                if(row!=0){
                    id[0] = row.id
                }else{
                    id = this.multipleSelection
                }
                if(id.length>0){
                    this.$confirm('此操作将永久删除该系列分组, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        let url = "zcvrVideoApi/imgList/deleteSeriesGroup/"+sessionStorage.getItem('sessionId')+"/"+id
                        this.$http.get(url,{emulateJson:true}).then(
                            (success)=>{
//				  				console.log(success)
                                if(success.data.msg=="ok"){
                                    this.$message({
                                        message: '删除成功',
                                        type: 'success'
                                    });
                                    this.getSeriesGroup()
                                }else{
                                    this.$message({
                                        message: success.data.msg,
                                        type: 'error'
                                    });
                                    if(success.data.msg=="该SessionId已经超时"){
                                        this.$message.error("登录超时！请重新登录");
                                        this.$router.push({path: '/',query: ''})
                                    }
                                }
                            },
                            (error)=>{
                                console.log("数据连接失败")
                            }
                        )
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        });
                    });
                }else{
                    this.$message({
                        type: 'info',
                        message: '请选择删除项'
                    });
                }
            },
        },
        mounted() {
            this.getSeriesGroup()
        },
    }
</script>

<style scoped>

</style>
